import { AdminToolbar } from "@opendash/ui";
import * as React from "react";
import { $framework, AdminLayout, useTranslation } from "..";
export const RouterLayoutBasic = React.memo(function RouterLayoutBasic({ children, ctx, padding, actions }) {
    const t = useTranslation();
    const title = t(ctx.title);
    const description = t(ctx.description);
    React.useEffect(() => {
        window.document.title = `${title} | ${$framework.ui2.name}`;
        return () => {
            window.document.title = $framework.ui2.name;
        };
    }, [title]);
    return (React.createElement(AdminLayout, { contentPadding: padding },
        React.createElement(AdminToolbar, { title: title, description: description, actions: actions }),
        React.createElement("div", { className: "od-page-main" }, children)));
});
//# sourceMappingURL=RouterLayoutBasic.js.map